export const year2026 = [
  { year: 2026 },
  {
    name: "FastAPI - The Complete Course 2026",
    author: "Eric Roby",
    type: "Course",
    link: "https://www.udemy.com/course/fastapi-the-complete-course",
    repo: "https://github.com/andreidobrinski/fastapi-the-complete-course-udemy",
  },
];
